"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = rerender;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _processrendering = _interopRequireDefault(require("./_processrendering"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// rerenders not rendered items in an array
// force rerender when forceRerender event option is truthy
function rerender() {
  var eventOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _this$renderIfPossibl = this.renderIfPossible,
      renderIfPossible = _this$renderIfPossibl === void 0 ? true : _this$renderIfPossibl;

  if (renderIfPossible) {
    (0, _processrendering["default"])({
      self: this,
      eventOptions: _objectSpread({
        method: 'rerender',
        added: [],
        removed: []
      }, eventOptions)
    });
  }

  return this;
}
//# sourceMappingURL=rerender.js.map